export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  fields: [{
    name: 'select-catalog',
    prop: 'selected',
    width: '40px',
    title: '',
    id: 'selectCatalog',
  }, {
    name: 'field-generic-input',
    prop: 'name',
    width: '220px',
    title: 'Item Name',
    id: 'name',
    sortField: 'name',
  }, {
    name: 'field-generic-input',
    prop: 'desc',
    width: '110px',
    title: 'Description',
    id: 'desc',
  }, {
    name: 'field-cat-id',
    prop: 'catId',
    width: '160px',
    title: 'Catalog ID',
    id: 'catId',
    sortField: 'catId',
  }, {
    name: 'field-generic-input',
    prop: 'available',
    width: '80px',
    title: 'In Stock',
    id: 'available',
  }, {
    name: 'qty-needed',
    prop: 'qtyNeeded',
    width: '156px',
    title: 'Qty Needed',
    id: 'qtyNeeded',
  }],
};
